var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBorderedStarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24.046,
    height: 23.309,
    viewBox: "0 0 24.046 23.309",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Path_25623",
    x: 0,
    y: 0,
    width: 24.046,
    height: 23.309,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.557
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    filter: "url(#Path_25623)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_25623-2",
    "data-name": "Path 25623",
    d: "M13.437,5.995l2.46,3.6a.172.172,0,0,0,.094.069l4.2,1.216a.172.172,0,0,1,.088.27L17.6,14.588a.172.172,0,0,0-.036.109l.135,4.35a.172.172,0,0,1-.23.167l-4.115-1.473a.181.181,0,0,0-.117,0L9.121,19.215a.172.172,0,0,1-.23-.167l.135-4.35a.172.172,0,0,0-.036-.109L6.312,11.147a.171.171,0,0,1,.088-.27l4.2-1.216a.168.168,0,0,0,.094-.069l2.46-3.6a.173.173,0,0,1,.285,0",
    transform: "translate(-2.27 -1.92)",
    fill: "#ffed7f",
    stroke: "#194792",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBorderedStarIcon);
export default __webpack_public_path__ + "static/media/bordered-star-icon.7ec6fd73efca90d563a3ad35a183c98b.svg";
export { ForwardRef as ReactComponent };